import React, { useContext } from 'react';
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Avatar from '@mui/material/Avatar';
import '../../App.css';
import { AppContext } from '../../contexts/AppContext';
import adriennePhoto from '../../images/plan-a-media-group-adrienne-wilkinson.png';

export default function Who() {
  const { useMobileView } = useContext(AppContext);

  return (
    <Box
      sx={{
        border: '2px solid white',
        borderRadius: '4px',
        padding: '24px',
        borderRight: useMobileView ? 'none' : '2px solid white'
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
            A bit about me...
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            Welcome to <b>Plan <span style={{ color: 'red' }}>A</span></b> Media group. I’m Adrienne Wilkinson. 
            While known mainly for my on-camera work, I've successfully consulted for over 20 years with professional 
            creatives who have returned time and again for input and direction to hone their ideas into successful 
            realities.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            I've helped producers evolve projects from 'it's not quite working' to award nominated, and aided writers in moving 
            scripts from 'uhhh, I'm stuck' to multiple award winners. I've assisted directors in the crafting of ground-breaking 
            projects, creators in nailing successful pitches, and have helped many an idea become a thriving creation. I 
            love being an asset in bringing dreams into existence...and in guiding creators back to their path if they feel they've 
            lost their way. I'm solution oriented, a natural problem solver and a safe-space providing confidential mentorship to 
            overcome the fears and frustrations that appear in the creative process. What began exclusively as favors for colleagues 
            (studio level professionals, thriving independent content creators, and those braving the entertainment industry for the 
            first time) is now available to you through <b>Plan <span style={{ color: 'red' }}>A</span></b> Media group.
          </Typography>
        </Grid>
        <Grid item xs={2} />
        <Grid item xs={10}>
          <Typography>
            {`I have worked in front of camera and behind the scenes in a variety of
            mediums in projects ranging from indie to some of the biggest franchises in the
            world...from award winning film and television to cutting edge online content, interactive
            media, animation and live events. I've read thousands of scripts, been a sought after
            judge at multiple film festivals, and walked the journey you are in the middle of...taking
            your work from idea to screen. For further information, visit `}
            <Link
              href="https://www.imdb.com/name/nm0929330/"
              target="_blank"
              rel="noreferrer"
              sx={{ color: 'red', textDecoration: 'none', fontWeight: 'bold' }}
            >
              IMDb
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            Wherever you are in the process, my goal is <b>to help you bring your vision from your mind, to the page, to the
            studio, to the screen, to the world.</b>
          </Typography>
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          <Avatar
            variant={"rounded"}
            src={adriennePhoto}
            alt="Plan A Media Group's Adrienne Wilkinson"
            sx={{ width: '50%', height: '100%' }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
